// frontend\src\components\ConfirmModal.js
import { BiX, BiTrash, BiCheck } from "react-icons/bi";

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Подтверждение удаления",
  message = "Вы уверены, что хотите удалить этот элемент? Это действие нельзя отменить.",
  confirmText = "Удалить",
  cancelText = "Отмена",
  type = "delete" 
}) => {
  if (!isOpen) return null;

  const getConfirmButtonClass = () => {
    switch (type) {
      case "delete":
        return "btn btn-danger";
      case "warning":
        return "btn btn-warning";
      case "success":
        return "btn btn-success";
      default:
        return "btn btn-primary";
    }
  };

  const getConfirmIcon = () => {
    switch (type) {
      case "delete":
        return <BiTrash className="me-1" />;
      case "warning":
        return <BiCheck className="me-1" />;
      case "success":
        return <BiCheck className="me-1" />;
      default:
        return <BiCheck className="me-1" />;
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {message}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              <BiX className="me-1" /> {cancelText}
            </button>
            <button
              type="button"
              className={getConfirmButtonClass()}
              onClick={onConfirm}
            >
              {getConfirmIcon()} {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;